import React from 'react';
import { useSelector } from 'react-redux';
import { getSelectedBank } from 'src/redux/modules/bankSelection/bankSelection.selectors';
import { getSelectedSchool } from 'src/redux/modules/schoolSelection';
import { getCharityNames } from 'src/redux/modules/qcd/qcd.selectors.js';
import { getDeliveryMethod } from 'src/redux/modules/sellDeliveryMethod/sellDeliveryMethod.selectors';
import {
  DELIVERY_DIRECT_DEPOSIT,
  DELIVERY_EXPRESS_DELIVERY,
  DELIVERY_IN_KIND,
  DELIVERY_MAIL_CHECK_TO_CHARITY,
  DELIVERY_MAIL_CHECK_TO_SCHOOL,
} from 'src/settings/settings';
import { titleCase } from 'src/utils/utils';
import StepCollapsed from '../../Shared/StepCollapsed/StepCollapsed';
import './DeliveryMethodChosen.scss';

export interface DeliveryMethodChosenProps {
  onEditClick(): void;
}
const getBankContent = (deliveryMethod, selectedBank) => {
  if (deliveryMethod === DELIVERY_DIRECT_DEPOSIT && selectedBank) {
    return (
      <div className="delivery-method-chosen-description">
        <span className="delivery-method-chosen-delivery-method">
          {' '}
          Direct Deposit:{' '}
        </span>
        <span className="delivery-method-chosen-bank-name">
          {titleCase(selectedBank.name)} -{' '}
          {`${titleCase(selectedBank.bankAccountType)} `}
          <span className="blocked_data">{selectedBank.accountNumber}</span>
        </span>
      </div>
    );
  } else if (deliveryMethod === DELIVERY_EXPRESS_DELIVERY && selectedBank) {
    return (
      <div className="delivery-method-chosen-description">
        <span className="delivery-method-chosen-delivery-method">
          {' '}
          Wire Transfer:{' '}
        </span>
        <span className="delivery-method-chosen-bank-name">
          {titleCase(selectedBank.name)} -{' '}
          {`${titleCase(selectedBank.bankAccountType)} `}
          <span className="blocked_data">{selectedBank.accountNumber}</span>
        </span>
      </div>
    );
  }
  return (
    <span className="delivery-method-chosen-description">
      {' '}
      Mail check to address on file{' '}
    </span>
  );
};
const DeliveryMethodChosen: React.VFC<DeliveryMethodChosenProps> = ({
  onEditClick,
}) => {
  const deliveryMethod = useSelector(getDeliveryMethod);
  const selectedBank = useSelector(getSelectedBank);
  const selectedSchool = useSelector(getSelectedSchool);
  const charityNamesList = useSelector(getCharityNames);
  const charityString = 'Mail check(s) to charity:' + charityNamesList;
  return (
    <div
      className="e2e-delivery-method-chosen delivery-method-chosen"
      onClick={onEditClick}
    >
      <StepCollapsed>
        {selectedBank ? (
          getBankContent(deliveryMethod, selectedBank)
        ) : deliveryMethod === DELIVERY_IN_KIND ? (
          <span className="delivery-method-chosen-description">
            {' '}
            In-Kind Transfer{' '}
          </span>
        ) : deliveryMethod === DELIVERY_MAIL_CHECK_TO_SCHOOL ? (
          <div className="delivery-method-chosen-description">
            <span className="delivery-method-chosen-delivery-method">
              {' '}
              Distribution to School:{' '}
            </span>
            <span className="delivery-method-chosen-bank-name">
              <span className="blocked_data">
                {selectedSchool?.schoolName || ''}
              </span>
            </span>
          </div>
        ) : deliveryMethod === DELIVERY_MAIL_CHECK_TO_CHARITY ? (
          <span className="delivery-method-chosen-description">
            {' '}
            {charityString.substring(0, 60)}
            {charityString.length > 60 && <span>...</span>}
          </span>
        ) : (
          <span className="delivery-method-chosen-description">
            {' '}
            Mail check to address on file{' '}
          </span>
        )}
        <a
          className="e2e-edit-button college-branded-link"
          id="sell-step-1-edit"
        >
          {' '}
          Edit{' '}
        </a>
      </StepCollapsed>
    </div>
  );
};

export default DeliveryMethodChosen;
